module.exports = __webpack_public_path__ + "img/submit.75fc7245.svg";